import { connect } from 'react-redux'
import TicketAssignmentDropdown from 'components/App/DesktopView/shared/AssignmentDropdown/Ticket'
import AssignmentButtonView from 'components/ConversationHeader/Buttons/AssignmentButton'

const select = () => ({
  AssignmentDropdown: TicketAssignmentDropdown,
})

export default connect(select)(AssignmentButtonView)
